const login = {
  path: 'login',
  component: resolve => require(['../../../pages/login'], resolve)
}

export default login
